var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("../assets/left_icon.png")},on:{"click":_vm.goBack}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }